<template>
  <div class="baseBackground">
    <div class="baseBackground__inn">
      <h1 class="baseBackground__title">
        <slot name="title"></slot>
      </h1>
      <div class="baseBackground__box" :class="[`baseBackground__box--m${margin}`]">
        <div class="baseBackground__contents">
          <slot></slot>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'AcademyBaseBackground',
  props: {
    // 上下のマージンを変更したい時に使用
    margin: {
      type: String,
      default: '7740',
    },
  }
}
</script>

<style lang="scss" scoped>
@import '../../../../../sass/commons/commonVariables.scss';

.baseBackground {
  padding: 0 unquote('min(3.2%, 30px)') 0;
  background: #fff;
  &__inn {
    background: url('/static/img/academy/bg.jpg') repeat 50% 0/930px auto;
    border-radius: 10px;
    overflow: hidden;
    position: relative;
    @include mq('pc'){
      background-size: cover;
    }
  }
  &__title {
    font-size: unquote('min(6.4vw, 30px)');
    line-height: 1.2;
    color: $academy_purple;
    text-align: center;
    margin: unquote('min(7.12%, 47px)') auto 0;
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    img {
      vertical-align: middle;
      max-width: 100%;
    }
  }
  &__box {
    background: #fff;
    border-radius: 10px;
    padding: unquote('min(6.55%, 60px)') 0 unquote('min(9.97%, 56px)');
    box-shadow: 5px 5px 5px rgba(0, 0, 0, 0.07);
    width: 93.16%;
    overflow: hidden;
    max-width: 590px;
    margin: auto;
    @include mq('w580'){
      min-width: 504px;
      width: 51.75%;
    }
    // w375 で上マージン 77px, 下マージン 40px
    &--m7740 {
      margin: unquote('min(21.93%, 130px)') auto unquote('min(11.396%, 60px)');
    }
    // w375 で上下マージン 77px
    &--m77 {
      margin: unquote('min(21.93%, 130px)') auto;
    }
    // w375 で上下マージン 40px
    &--m40 {
      margin: unquote('min(11.396%, 60px)') auto;
    }
  }
  &__contents {
    margin: auto;
    width: 87.76%;
    max-width: 360px;
  }
}
</style>



// WEBPACK FOOTER //
// ../../../../resources/assets/js/utvStore/components/Academy/partials/BaseBackground.vue